"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.getIsHost = exports.getPingTime = exports.getMultiName = exports.isUsEx = exports.isUs = exports.getMultiId = exports.getIsSingleplayer = void 0;
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var crokinoleMultiplayerCursors_sidecar_1 = require("@crokinole/cursors/crokinoleMultiplayerCursors-sidecar");
var crokinoleDefs_sidecar_1 = require("@crokinole/main/crokinoleDefs-sidecar");
var crokinoleWebsockets_extensions_sidecar_1 = require("./crokinoleWebsockets_extensions-sidecar");
function getIsSingleplayer() {
    return websockets_sidecar_1.websockets.getIsSingleplayer();
}
exports.getIsSingleplayer = getIsSingleplayer;
function getMultiId() {
    return websockets_sidecar_1.websockets.getMultiId();
}
exports.getMultiId = getMultiId;
function isUs(multiId) {
    return multiId === websockets_sidecar_1.websockets.getMultiId();
}
exports.isUs = isUs;
function isUsEx(multiId) {
    var _isUs = isUs(multiId);
    var from = crokinoleMultiplayerCursors_sidecar_1.crokinoleMultiplayerCursors.findByMultiIdSafe(multiId);
    if (!_isUs && !from) {
        console.warn('isUsEx', 'no from', multiId);
    }
    return { isUs: _isUs, from: from };
}
exports.isUsEx = isUsEx;
function getMultiName() {
    return websockets_sidecar_1.websockets.getMultiName();
}
exports.getMultiName = getMultiName;
function getPingTime() {
    return websockets_sidecar_1.websockets.getPingTime();
}
exports.getPingTime = getPingTime;
function getIsHost() {
    return websockets_sidecar_1.websockets.getIsHost();
}
exports.getIsHost = getIsHost;
function create() {
    websockets_sidecar_1.websockets.create(crokinoleWebsockets_extensions_sidecar_1.crokinoleWebsockets_extensions, crokinoleDefs_sidecar_1.crokinoleDefs.multiplayerVersion);
    websockets_sidecar_1.websockets.tryConnect();
}
exports.create = create;
